// To activate a local mockup, import the existing PNG and replace its null value.
// Example:
// import identityBlackFront from "../assets/merch/identity-tee/faded-black-front.png";
// Then set: "Faded Black": { front: identityBlackFront, back: null }
export const merchAssets = {
  "identity-tee": {
    "Faded Black": { front: null, back: null },
    "Faded Bone": { front: null, back: null },
    "Faded Coal": { front: null, back: null }
  },
  "archive-tee": {
    "Faded Black": { front: null, back: null },
    "Faded Bone": { front: null, back: null },
    "Faded Coal": { front: null, back: null }
  },
  "scan-my-build-tee": {
    "Faded Black": { front: null, back: null },
    "Faded Bone": { front: null, back: null },
    "Faded Coal": { front: null, back: null }
  }
};

export function getMerchAsset(galleryKey, color, view) {
  return merchAssets[galleryKey]?.[color]?.[view] || null;
}
